module.exports = __webpack_public_path__ + "static/media/slider2.71c5e837.png";